import { useEffect } from "react";
import { colors, type, spacing } from "@/theme";
import { PRIVACY_TEXT } from "@/content/site";
import SiteFooter from "@/components/SiteFooter";

export default function Privacy() {
  useEffect(() => { document.title = "Privacy | Tavoline"; }, []);
  return (
    <div style={{ minHeight: "100vh", background: colors.paper }}>
      <div style={{ width: "100%", maxWidth: 680, margin: "0 auto", padding: `${spacing.xl}px ${spacing.lg}px`, display: "flex", flexDirection: "column", gap: spacing.lg }}>
        <h1 style={{ ...type.serif, fontSize: 36, lineHeight: "40px", color: colors.ink, margin: 0 }}>Informativa sulla privacy</h1>
        <div data-testid="site-privacy-text" style={{ ...type.sans, fontSize: 16, lineHeight: "26px", color: colors.ink, whiteSpace: "pre-wrap" }}>{PRIVACY_TEXT}</div>
        <SiteFooter />
      </div>
    </div>
  );
}
